<template>
    <div class="dialog-stack-container relative mx-auto w-full max-w-full overflow-hidden sm:max-w-2xl md:max-w-5xl">
        <slot :get-dialog-style="getDialogStyle" :get-content-style="getContentStyle" />
    </div>
</template>

<script>
export default {
    name: 'DialogStack',

    props: {
        activeIndex: {
            type: Number,
            required: true,
        },
        totalDialogs: {
            type: Number,
            required: true,
        },
        offset: {
            type: Number,
            default: 8,
        },
        scaleReduction: {
            type: Number,
            default: 0.025,
        },
        widthReduction: {
            type: Number,
            default: 16,
        },
    },

    methods: {
        getDialogStyle(index) {
            const distanceFromActive = index - this.activeIndex
            const isActive = distanceFromActive === 0
            const translateY = distanceFromActive < 0 ? Math.abs(distanceFromActive) * this.offset : 0
            const scale = distanceFromActive < 0 ? 1 - Math.abs(distanceFromActive) * this.scaleReduction : 1
            const widthReduction = Math.abs(distanceFromActive) * this.widthReduction

            return {
                position: distanceFromActive < 0 ? 'absolute' : 'relative',
                top: distanceFromActive < 0 ? 0 : 'auto',
                left: 0,
                right: 0,
                margin: '0 auto',
                width: '100%',
                maxWidth: `calc(100% - ${widthReduction}px)`,

                transform: `translateY(-${translateY}px) scale(${scale})`,
                transformOrigin: 'center top',

                zIndex: index,
                pointerEvents: isActive ? 'auto' : 'none',
                overflow: 'hidden',
                transition: 'all 300ms cubic-bezier(0.4, 0, 0.2, 1)',
            }
        },

        getContentStyle(index) {
            const isActive = index === this.activeIndex
            return {
                opacity: isActive ? 1 : 0,
                pointerEvents: isActive ? 'auto' : 'none',
                transition: 'opacity 300ms ease-in-out',
                visibility: isActive ? 'visible' : 'hidden',
            }
        },
    },
}
</script>
